import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
import {FaCode, FaCloud, FaChalkboardTeacher, FaMobile} from 'react-icons/fa'

const Services = () => {
  return (
    <section id='services'>
      {/* Floating Background Elements */}
      <div className="services__floating-element"></div>
      <div className="services__floating-element"></div>
      
      {/* Section Header */}
      <div className="services__header">
        <span className="services__badge">What I Offer</span>
        <h2 className="services__main-title">My Services</h2>
        <p className="services__subtitle">
          Comprehensive development solutions tailored to bring your digital vision to life
        </p>
      </div>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <FaCode className="service__icon" />
            <h3>Full-Stack Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>React & Angular Applications</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Java & Python Backend Systems</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Database Design & SQL Operations</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>RESTful API Development</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Code Promotion & Testing</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Performance Optimization (25% improvement)</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <FaCloud className="service__icon" />
            <h3>Cloud Computing & DevOps</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Microsoft Azure Solutions</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Azure DevOps Implementation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>CI/CD Pipeline Setup</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Cloud Infrastructure Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Production Environment Management</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>System Monitoring & Maintenance</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <FaMobile className="service__icon" />
            <h3>Mobile & Software Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Android App Development</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Firebase Integration</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Google Sign-In Implementation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>CSV Data Processing Systems</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Location Tracking & Mapping</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Educational Software Solutions</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <FaChalkboardTeacher className="service__icon" />
            <h3>Training & Consultation</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Computer Lab Instruction</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Programming Mentorship</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Course Content Development</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Student Progress Assessment</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Technical Documentation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Project Management</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services